import { useState } from 'react';
import { Box, TextField, Button, Typography, CircularProgress } from '@mui/material';
import Modal from 'shared/Modal';
import { useCheckOdbcCredentialsMutation } from 'IntegrationModule/api/queries/useCheckOdbcCredentialsMutation';
import { ModalPropsToOverride } from 'components/DynamicModalProvider/types';

type OdbcCredentialCheckModalProps = ModalPropsToOverride;

const OdbcCredentialCheckModal = ({ isOpen, toggle }: OdbcCredentialCheckModalProps) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [dataSource, setDataSource] = useState('');
  const [serviceUrl, setServiceUrl] = useState('');

  const { checkOdbcCredentials, isCheckingOdbcCredentials } = useCheckOdbcCredentialsMutation({
    onSuccess: toggle,
  });

  const isFormValid = username && password && dataSource && serviceUrl;

  const handleCheck = () => {
    if (!isFormValid) return;

    checkOdbcCredentials({
      username,
      password,
      dataSource,
      serviceUrl,
    });
  };

  return (
    <Modal open={isOpen} onClose={toggle} modalWidth={450}>
      <Box>
        <Typography variant="h6" sx={{ mb: 3 }}>
          Check ODBC Credentials
        </Typography>

        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            required
            size="small"
          />

          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            required
            size="small"
          />

          <TextField
            label="Data Source"
            value={dataSource}
            onChange={(e) => setDataSource(e.target.value)}
            fullWidth
            required
            size="small"
          />

          <TextField
            label="Service URL"
            value={serviceUrl}
            onChange={(e) => setServiceUrl(e.target.value)}
            fullWidth
            required
            size="small"
          />
        </Box>

        <Box display="flex" justifyContent="flex-end" mt={3}>
          <Button
            variant="contained"
            onClick={handleCheck}
            disabled={!isFormValid || isCheckingOdbcCredentials}
          >
            {isCheckingOdbcCredentials ? <CircularProgress size={20} color="inherit" /> : 'Check'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default OdbcCredentialCheckModal;
